import { Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core'
import { Chart, ChartConfiguration, ChartType } from 'chart.js/auto'

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.css'],
  imports: [],
})
export class ChartComponent implements OnChanges {
  @ViewChild('canvas', { static: true }) canvas!: ElementRef<HTMLCanvasElement>
  @Input({ required: true }) chartConfig!: ChartConfiguration & { title?: string }

  private _chart: Chart<ChartType> | undefined

  ngOnChanges() {
    this._createChart()
  }

  private _createChart() {
    this._resetChart()
    if (!this.canvas) {
      console.error('ChartComponent: canvas is not defined')
      return
    }
    const ctx = this.canvas.nativeElement.getContext('2d')
    if (ctx) this._chart = new Chart(ctx, this.chartConfig)
  }

  private _resetChart() {
    if (this._chart) {
      this._chart.destroy()
      this._chart = void 0
    }
  }
}
